module.exports = __webpack_public_path__ + "static/RST-CD-7e3d43c45d412406f5c2ed37f69720a7.jpg";